import React from 'react';
import './index.less';
export default function (props) {
    const { visible, children, style = {}, className = '' } = props;
    return visible ? React.createElement("div", { className: `oflow-editor--pop-over ${className}`, style: style }, children) : null;
}
//# sourceMappingURL=index.js.map